<template>
    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          <strong>Bulma</strong> by <a href="https://jgthms.com">Jeremy Thomas</a>. The source code is licensed
          <a href="http://opensource.org/licenses/mit-license.php">MIT</a>. The website content
          is licensed <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/">CC BY NC SA 4.0</a>.
        </p>
      </div>
    </footer>
</template>

<style scoped>
footer.footer {
    background-color: #fff;
}
</style>

<script>
export default {
  name: 'Footer',
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue